// Central content for Fairy Yasha
export const BRAND = {
  name: "Fairy Yasha",
  tagline: "Intuition · Healing · Empowerment · Transformation",
};

export const ASSETS = {
  heroPoster: "https://customer-assets-cm19k8pv.emergentagent.net/job_ethereal-night/artifacts/z9qlxvil_IMG_8830%202.PNG",
  aboutPoster: "https://customer-assets-cm19k8pv.emergentagent.net/job_ethereal-night/artifacts/4yuxnlss_IMG_8826%202.PNG",
  aboutPhoto: "https://customer-assets-cm19k8pv.emergentagent.net/job_ethereal-night/artifacts/1za328g3_580dfb38-c377-4957-b78a-b6ee0136355a.png",
  velvetStars: "https://customer-assets-cm19k8pv.emergentagent.net/job_ethereal-night/artifacts/8vf71y5j_IMG_8884.PNG",
};

export const SUPPORT = [
  { key: "readings", icon: "moon", title: "Psychic Readings", desc: "Gain clarity and insight on love, life, purpose & more." },
  { key: "healing", icon: "gem", title: "Energy Healing", desc: "Release what no longer serves you and restore energetic balance." },
  { key: "spellwork", icon: "eye", title: "Spellwork & Rituals", desc: "Custom rituals to support your desires and spiritual evolution." },
  { key: "parties", icon: "party", title: "Parties & Events", desc: "Psychic entertainment for bachelorettes, birthdays, girls' nights, divorce parties & pop-ups." },
  { key: "shop", icon: "sparkles", title: "Shop", desc: "Handcrafted spiritual tools to elevate your practice and energy." },
];

export const TAROT_CARDS = [
  { name: "The Moon", roman: "XVIII", icon: "moon", reading: "Trust the intuition stirring beneath the surface — not everything is as it seems, and your inner knowing is the truest map." },
  { name: "The Star", roman: "XVII", icon: "star", reading: "Hope returns like first light. Let yourself dream again; the universe is quietly conspiring in your favor." },
  { name: "The Lovers", roman: "VI", icon: "heart", reading: "A union of hearts, or a choice made in love. Follow what feels honest and let devotion guide the way." },
  { name: "The Empress", roman: "III", icon: "crown", reading: "Abundance and tenderness surround you. Nurture what you wish to grow and receive care in return." },
  { name: "The High Priestess", roman: "II", icon: "eye", reading: "Secrets whisper at the edge of knowing. Be still, listen inward, and trust the answer already forming." },
  { name: "The Sun", roman: "XIX", icon: "sun", reading: "Joy and clarity light your path. Step boldly into the warmth — this is a season of blossoming." },
  { name: "Wheel of Fortune", roman: "X", icon: "wheel", reading: "The tides are turning in your favor. Release your grip and let the change that's arriving carry you." },
  { name: "Strength", roman: "VIII", icon: "flame", reading: "Gentle courage conquers all. Your softness is your power; lead with an open, steady heart." },
  { name: "The World", roman: "XXI", icon: "globe", reading: "A cycle completes in quiet triumph. You are exactly where you are meant to be — honor how far you've come." },
  { name: "Temperance", roman: "XIV", icon: "droplets", reading: "Balance is being restored. Blend patience with passion and let the extremes settle into harmony." },
];

export const REVIEWS = [
  { text: "On point as usual… 100% accuracy… I trust no other.", author: "Raja108" },
  { text: "Thank you for the beautiful advice and insight! 💜💜💜", author: "Willow" },
  { text: "Great reading, very down to earth. 💫", author: "BobbieM" },
  { text: "Always there to help me through this life.", author: "Dani" },
  { text: "She's so sweet and feels like a safe space to share! Highly recommend.", author: "Gabi" },
  { text: "Thank you so incredibly much for a wonderful, wonderful reading!!! 🙏🌟", author: "Michelle" },
];

export const DELIVERY_OPTIONS = [
  "Live Video Chat",
  "Phone Call",
  "Live Text Chat",
  "Pre-recorded Video",
];

export const SERVICE_OPTIONS = [
  "Psychic Reading",
  "Energy Healing",
  "Spellwork & Rituals",
  "Parties & Events",
  "Not sure yet — guide me",
];
